import React from 'react';
import * as Yup from 'yup';
import { printAction } from "../../../../actions";
import { PRINT } from "../../../../consts/methods.consts";
import { StylishCell } from '../components/cells';


const EvaluationSummaryReportConfig = {
    searchApi: 'xceed.api.report.module_evaluation.get_evaluation_summary_report',
    alert: 'Reminder: Specify a program to receive reports.',
    excelFileName: 'evaluation-summary-report',
    title: 'Evaluation Summary Report',
    // extraActionsAsMenu: true,
    pagination: false,
    sections: [
        {
            selectionTitle: "Filters",
            grid: { base: 1, md: 2, lg: 4, xl: 4 },
            filters: [
                {
                    is_required: true,
                    label: 'Program Coordinator',
                    key: 'p_coordinator',
                    type: 'form-online-search',
                    methodBody: {},
                    optionMethod: 'xceed.api.report.module_evaluation.get_program_coordinators',
                    validationSchema: Yup.string().required('Program is required'),
                    onChange: (formik: any) => {
                        if (!formik.values.program) {
                            formik.setFieldValue('program', '')

                        }
                    }
                },
                {
                    label: 'Program',
                    key: 'program',
                    type: 'form-online-search',
                    methodBody: { "p_coordinator": "p_coordinator" },
                    optionMethod: 'xceed.api.report.module_evaluation.get_related_programs',
                    disabledBaseOn: ["p_coordinator"],
                },
            ]
        }],

    tableConfig: {
        column: [
            {
                header: "Module Name",
                accessor: "program_module_title",
                width: 200
            },
            {
                header: "Coordinator",
                accessor: "coordinator",
                width: 200
            },
            {
                header: "Coordinator Marks",
                accessor: "coordination_rating",
                width: 50,
                headerOptions: {
                    className: " !justify-end"
                },
                customRenderer: (value: any, item: any) => React.createElement(StylishCell, { className: "flex justify-end", value })
            },
            {
                header: "Class Room Facility Marks",
                accessor: "class_room_rating",
                width: 50,
                headerOptions: {
                    className: " !justify-end"
                },
                customRenderer: (value: any, item: any) => React.createElement(StylishCell, { className: "flex justify-end", value })
            },
            {
                header: "Computer Lab Facility Marks",
                accessor: "computer_lab_rating",
                width: 50,
                headerOptions: {
                    className: " !justify-end"
                },
                customRenderer: (value: any, item: any) => React.createElement(StylishCell, { className: "flex justify-end", value })
            },
            {
                header: "Hostel Facility Marks",
                accessor: "hostel_rating",
                width: 50,
                headerOptions: {
                    className: " !justify-end"
                },
                customRenderer: (value: any, item: any) => React.createElement(StylishCell, { className: "flex justify-end", value })
            },
            {
                header: "Library Facility Marks",
                accessor: "library_rating",
                width: 50,
                headerOptions: {
                    className: " !justify-end"
                },
                customRenderer: (value: any, item: any) => React.createElement(StylishCell, { className: "flex justify-end", value })
            },
            {
                header: "Cafeteria Facility Marks",
                accessor: "cafeteria_rating",
                width: 50,
                headerOptions: {
                    className: " !justify-end"
                },
                customRenderer: (value: any, item: any) => React.createElement(StylishCell, { className: "flex justify-end", value })
            },
            {
                header: "Overall Marks",
                accessor: "overall_rating",
                width: 50,
                headerOptions: {
                    className: " !justify-end"
                },
                customRenderer: (value: any, item: any) => React.createElement(StylishCell, { className: "flex justify-end", value })
            },
        ]
    },
    actions: [

        {
            text: "Print Report",
            onClick: async (filter: any, data: any, setLoading: any) => {
                if (filter.program && filter.p_coordinator) {
                    setLoading(true)
                    setLoading(true);
                    try {
                        await printAction(PRINT.PRINT_MODULE_EVALUATION_SUMMARY_REPORT, { filter }, setLoading);
                    } catch (error: any) {
                        setLoading(false);
                        const newError: any = new Error("Unable to print report");
                        newError.title = "Error";
                        newError.status = "error";
                        throw newError;
                    }
                }
                else {
                    const error: any = new Error('Please select program coordinator and program');
                    error.title = 'Warning';
                    error.status = 'warning';
                    throw error
                }
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        }
    ]
}

export default EvaluationSummaryReportConfig